import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 4.714a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428M6.731 8.651C7.921 7.221 9.703 6.286 12 6.286s4.077.935 5.268 2.365C18.44 10.06 19 11.895 19 13.686v3.581a3 3 0 0 1-2.995 3l-1.438.003c-.032.506-.252 1.294-.853 1.838l-.04.035c-.388.336-.93.571-1.674.571-.736 0-1.276-.23-1.664-.562l-.01-.01c-.627-.54-.858-1.346-.893-1.863l-1.428.003a3 3 0 0 1-3.005-3v-3.596c0-1.79.56-3.627 1.731-5.035",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_bell_filled-DwE2z4LD.js.map
